import React from 'react';
import { BarChart3 } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface BarChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const BarChartIcon: React.FC<BarChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <BarChart3 size={size} color={color} />
        </IconWrapper>
    );
};
